import { render, staticRenderFns } from "./BallCont.vue?vue&type=template&id=21a1f638&scoped=true"
import script from "./BallCont.vue?vue&type=script&lang=js"
export * from "./BallCont.vue?vue&type=script&lang=js"
import style0 from "./BallCont.vue?vue&type=style&index=0&id=21a1f638&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1f638",
  null
  
)

export default component.exports